import React, {useContext, useState} from 'react';
import {
    SafeAreaView,
    ScrollView,
    StatusBar,
    StyleSheet,
    Text,
    TouchableOpacity,
    View,
    Modal,
    Button,
    Alert,
    Platform, Switch, TextInput
} from 'react-native';
import FeatherIcon from 'react-native-vector-icons/Feather';
import { LinearGradient } from "expo-linear-gradient";
import {SystemContext} from "../helpers/SystemContext";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useTranslation } from 'react-i18next';

export default function DesignSettingsScreen({ navigation }) {
    const { t } = useTranslation();
    const { 
        defaultView, 
        setEventColumnCount, 
        setCategoryColumnCount, 
        productDisplayMode, 
        setProductDisplayMode, 
        productColumnCount, 
        setProductColumnCount,
        categoryColumnCount
    } = useContext(SystemContext);

    const [modalVisible, setModalVisible] = useState(false);
    const [selectedDefaultView, setSelectedDefaultView] = useState(defaultView || 'categories');
    const [columnModalVisible, setColumnModalVisible] = useState(false);
    const [eventModalVisible, setEventModalVisible] = useState(false);
    const [productDisplayModalVisible, setProductDisplayModalVisible] = useState(false);
    const [productColumnModalVisible, setProductColumnModalVisible] = useState(false);
    const [columnInput, setColumnInput] = useState('');
    const [eventInput, setEventInput] = useState('');
    const [productColumnInput, setProductColumnInput] = useState('');

    const handleDefaultViewChange = (view) => {
        setSelectedDefaultView(view);
        AsyncStorage.setItem('defaultView', view);
        setModalVisible(false);
    };

    const handleColumnSetting = () => {
        setColumnModalVisible(true);
    };

    const handleEventSetting = () => {
        setEventModalVisible(true);
    };

    const handleProductDisplaySetting = () => {
        setProductDisplayModalVisible(true);
    };

    const handleProductColumnSetting = () => {
        setProductColumnModalVisible(true);
    };

    // handleColumnSubmit is no longer needed as the column count is set directly in the button's onPress handler

    const handleEventSubmit = () => {
        AsyncStorage.setItem('eventColumnCount', eventInput);
        setEventColumnCount(Number(eventInput));
        setEventModalVisible(false);
    };

    const handleProductDisplayChange = (mode) => {
        setProductDisplayMode(mode);
        setProductDisplayModalVisible(false);
    };

    const handleProductColumnSubmit = () => {
        const columnCount = Number(productColumnInput);
        // Ensure the column count is between 1 and 5
        const validColumnCount = Math.min(Math.max(columnCount, 1), 5);
        setProductColumnCount(validColumnCount);
        AsyncStorage.setItem('productColumnCount', validColumnCount.toString());
        setProductColumnModalVisible(false);
    };

    return (
        <LinearGradient
            colors={['#EAE5EE', '#FEE6DE', '#EBE5F2']}
            style={{ flex: 1, width: '100%', height: '100%' }}
        >
            <SafeAreaView style={{ flex: 1, backgroundColor: 'transparent', paddingTop: 10 }}>
                <StatusBar backgroundColor="transparent" translucent barStyle="dark-content" />
                <ScrollView contentContainerStyle={styles.content}>
                    <View style={styles.section}>
                        <Text style={styles.sectionTitle}>{t('design_settings')}</Text>
                        <View style={styles.sectionBody}>
                            <TouchableOpacity
                                style={styles.row}
                                activeOpacity={1}
                                onPress={() => setModalVisible(true)}
                            >
                                <Text style={styles.rowLabel}>{t('default_sales_view')}</Text>
                                <View style={styles.rowSpacer} />
                                <FeatherIcon
                                    color="#bcbcbc"
                                    name="chevron-right"
                                    size={19}
                                />
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={styles.row}
                                activeOpacity={1}
                                onPress={handleColumnSetting}
                            >
                                <Text style={styles.rowLabel}>{t('category_view_columns')}</Text>
                                <View style={styles.rowSpacer} />
                                <FeatherIcon
                                    color="#bcbcbc"
                                    name="chevron-right"
                                    size={19}
                                />
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={styles.row}
                                activeOpacity={1}
                                onPress={handleEventSetting}
                            >
                                <Text style={styles.rowLabel}>{t('events_per_row')}</Text>
                                <View style={styles.rowSpacer} />
                                <FeatherIcon
                                    color="#bcbcbc"
                                    name="chevron-right"
                                    size={19}
                                />
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={styles.row}
                                activeOpacity={1}
                                onPress={handleProductDisplaySetting}
                            >
                                <Text style={styles.rowLabel}>{t('product_display_mode')}</Text>
                                <View style={styles.rowSpacer} />
                                <FeatherIcon
                                    color="#bcbcbc"
                                    name="chevron-right"
                                    size={19}
                                />
                            </TouchableOpacity>
                            {productDisplayMode === 'grid' && (
                                <TouchableOpacity
                                    style={styles.row}
                                    activeOpacity={1}
                                    onPress={handleProductColumnSetting}
                                >
                                    <Text style={styles.rowLabel}>{t('product_grid_columns')}</Text>
                                    <View style={styles.rowSpacer} />
                                    <FeatherIcon
                                        color="#bcbcbc"
                                        name="chevron-right"
                                        size={19}
                                    />
                                </TouchableOpacity>
                            )}
                        </View>
                    </View>
                </ScrollView>
            </SafeAreaView>

            {modalVisible && <Modal
                animationType="slide"
                transparent={true}
                visible={modalVisible}
                onRequestClose={() => setModalVisible(false)}
            >
                <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>
                        <Text style={styles.modalTitle}>{t('default_sales_view')}</Text>
                        <TouchableOpacity style={styles.modalButton} onPress={() => handleDefaultViewChange('events')}>
                            <Text style={styles.modalButtonText}>{t('events_tickets')}</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={styles.modalButton}
                                          onPress={() => handleDefaultViewChange('categories')}>
                            <Text style={styles.modalButtonText}>{t('categories_products')}</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={styles.closeButton} onPress={() => setModalVisible(false)}>
                            <Text style={styles.closeButtonText}>{t('cancel')}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </Modal>}

            {columnModalVisible && <Modal
                animationType="slide"
                transparent={true}
                visible={columnModalVisible}
                onRequestClose={() => setColumnModalVisible(false)}
            >
                <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>
                        <Text style={styles.modalTitle}>{t('category_view_columns')}</Text>
                        <Text style={styles.modalSubtitle}>{t('category_grid_columns_description')}</Text>
                        <View style={styles.columnButtonsContainer}>
                            {[1, 2, 3, 4, 5].map(count => (
                                <TouchableOpacity 
                                    key={count} 
                                    style={[
                                        styles.columnButton, 
                                        categoryColumnCount === count && styles.columnButtonSelected
                                    ]} 
                                    onPress={() => {
                                        setColumnInput(count.toString());
                                        setCategoryColumnCount(count);
                                        AsyncStorage.setItem('categoryColumnCount', count.toString());
                                        setColumnModalVisible(false);
                                    }}
                                >
                                    <Text style={[
                                        styles.columnButtonText, 
                                        categoryColumnCount === count && styles.columnButtonTextSelected
                                    ]}>{count}</Text>
                                </TouchableOpacity>
                            ))}
                        </View>
                        <TouchableOpacity style={styles.closeButton} onPress={() => setColumnModalVisible(false)}>
                            <Text style={styles.closeButtonText}>{t('cancel')}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </Modal>}

            {eventModalVisible && <Modal
                animationType="slide"
                transparent={true}
                visible={eventModalVisible}
                onRequestClose={() => setEventModalVisible(false)}
            >
                <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>
                        <Text style={styles.modalTitle}>{t('events_per_row')}</Text>
                        <TextInput
                            style={styles.input}
                            placeholder={t('how_many_events_to_display')}
                            keyboardType="numeric"
                            value={eventInput}
                            onChangeText={setEventInput}
                        />
                        <TouchableOpacity style={styles.modalButton} onPress={handleEventSubmit}>
                            <Text style={styles.modalButtonText}>{t('ok')}</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={styles.closeButton} onPress={() => setEventModalVisible(false)}>
                            <Text style={styles.closeButtonText}>{t('cancel')}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </Modal>}

            {productDisplayModalVisible && <Modal
                animationType="slide"
                transparent={true}
                visible={productDisplayModalVisible}
                onRequestClose={() => setProductDisplayModalVisible(false)}
            >
                <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>
                        <Text style={styles.modalTitle}>{t('product_display_mode')}</Text>
                        <TouchableOpacity style={styles.modalButton} onPress={() => handleProductDisplayChange('list')}>
                            <Text style={styles.modalButtonText}>{t('list')}</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={styles.modalButton} onPress={() => handleProductDisplayChange('grid')}>
                            <Text style={styles.modalButtonText}>{t('grid')}</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={styles.closeButton} onPress={() => setProductDisplayModalVisible(false)}>
                            <Text style={styles.closeButtonText}>{t('cancel')}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </Modal>}

            {productColumnModalVisible && <Modal
                animationType="slide"
                transparent={true}
                visible={productColumnModalVisible}
                onRequestClose={() => setProductColumnModalVisible(false)}
            >
                <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>
                        <Text style={styles.modalTitle}>{t('product_grid_columns')}</Text>
                        <Text style={styles.modalSubtitle}>{t('product_grid_columns_description')}</Text>
                        <View style={styles.columnButtonsContainer}>
                            {[1, 2, 3, 4, 5].map(count => (
                                <TouchableOpacity 
                                    key={count} 
                                    style={[
                                        styles.columnButton, 
                                        productColumnCount === count && styles.columnButtonSelected
                                    ]} 
                                    onPress={() => {
                                        setProductColumnInput(count.toString());
                                        setProductColumnCount(count);
                                        AsyncStorage.setItem('productColumnCount', count.toString());
                                        setProductColumnModalVisible(false);
                                    }}
                                >
                                    <Text style={[
                                        styles.columnButtonText, 
                                        productColumnCount === count && styles.columnButtonTextSelected
                                    ]}>{count}</Text>
                                </TouchableOpacity>
                            ))}
                        </View>
                        <TouchableOpacity style={styles.closeButton} onPress={() => setProductColumnModalVisible(false)}>
                            <Text style={styles.closeButtonText}>{t('cancel')}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </Modal>}
        </LinearGradient>
    );
}

const styles = StyleSheet.create({
    content: {
        paddingHorizontal: 16,
        backgroundColor: 'transparent'
    },
    section: {
        paddingVertical: 12,
    },
    sectionTitle: {
        margin: 8,
        marginLeft: 12,
        fontSize: 13,
        letterSpacing: 0.33,
        fontWeight: '500',
        color: '#a69f9f',
        textTransform: 'uppercase',
    },
    modalSubtitle: {
        fontSize: 16,
        marginBottom: 15,
        textAlign: 'center',
        color: '#666',
    },
    columnButtonsContainer: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        marginBottom: 20,
        width: '100%',
    },
    columnButton: {
        width: 50,
        height: 50,
        borderRadius: 25,
        backgroundColor: '#f0f0f0',
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 1,
        borderColor: '#ddd',
    },
    columnButtonSelected: {
        backgroundColor: '#007bff',
        borderColor: '#0056b3',
    },
    columnButtonText: {
        fontSize: 18,
        fontWeight: 'bold',
        color: '#333',
    },
    columnButtonTextSelected: {
        color: '#fff',
    },
    sectionBody: {
        borderRadius: 12,
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.5,
        shadowRadius: 1.41,
        elevation: 3,
    },
    row: {
        height: 44,
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingRight: 12,
        paddingLeft: 16,
        backgroundColor: '#fff',
        borderTopWidth: 1,
        borderColor: '#f0f0f0',
    },
    rowLabel: {
        fontSize: 16,
        letterSpacing: 0.24,
        color: '#000',
    },
    rowSpacer: {
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 0,
    },
    modalContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    modalContent: {
        width: '80%',
        backgroundColor: 'white',
        borderRadius: 10,
        padding: 20,
        alignItems: 'center',
    },
    modalTitle: {
        fontSize: 20,
        fontWeight: 'bold',
        marginBottom: 20,
    },
    modalButton: {
        backgroundColor: '#2196F3',
        borderRadius: 5,
        padding: 10,
        marginVertical: 5,
        width: '100%',
        alignItems: 'center',
    },
    modalButtonText: {
        color: 'white',
        fontWeight: 'bold',
    },
    closeButton: {
        marginTop: 20,
        backgroundColor: '#f44336',
        borderRadius: 5,
        padding: 10,
        width: '100%',
        alignItems: 'center',
    },
    closeButtonText: {
        color: 'white',
        fontWeight: 'bold',
    },
    input: {
        width: '100%',
        padding: 10,
        borderColor: '#ccc',
        borderWidth: 1,
        borderRadius: 5,
        marginBottom: 10,
    },
});
